import { getIdToken } from './auth';

const BASE_URL = import.meta.env.VITE_API_URL || '';
const GMAIL_API_URL = import.meta.env.VITE_GMAIL_API_URL || '';

export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

function createClient(baseUrl: string) {
  async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
    const token = await getIdToken();
    if (!token) {
      window.location.href = '/login';
      throw new ApiError(401, 'Not authenticated');
    }

    const headers: Record<string, string> = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    const res = await fetch(`${baseUrl}${path}`, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    });

    if (res.status === 401) {
      window.location.href = '/login';
      throw new ApiError(401, 'Session expired');
    }

    const data = await res.json();

    if (!res.ok) {
      throw new ApiError(res.status, data.error || 'Request failed');
    }

    return data as T;
  }

  return {
    get: <T>(path: string) => request<T>('GET', path),
    post: <T>(path: string, body?: unknown) => request<T>('POST', path, body),
    put: <T>(path: string, body?: unknown) => request<T>('PUT', path, body),
    delete: <T>(path: string) => request<T>('DELETE', path),
  };
}

export const api = createClient(BASE_URL);
export const gmailApi = createClient(GMAIL_API_URL);
